import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const TaskFilters = ({ filters, selected, onSelect, counts }) => {
  const strip = useRef(null);
  const [edges, setEdges] = useState({ overflow: false, start: true, end: true });
  useEffect(() => {
    const element = strip.current;
    const update = () => setEdges({ overflow: element.scrollWidth > element.clientWidth + 2, start: element.scrollLeft < 2, end: element.scrollLeft + element.clientWidth >= element.scrollWidth - 2 });
    const observer = new ResizeObserver(update);
    observer.observe(element);
    element.addEventListener('scroll', update, { passive: true });
    update();
    return () => { observer.disconnect(); element.removeEventListener('scroll', update); };
  }, [counts]);
  const scroll = direction => strip.current.scrollBy({ left: direction * strip.current.clientWidth * .8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  return <div className="task-filter-bar" data-testid="task-filter-bar">
    {edges.overflow && <Button size="icon" variant="ghost" disabled={edges.start} onClick={() => scroll(-1)} aria-label="Previous task filters" title="Previous filters" data-testid="task-filters-previous"><ChevronLeft size={16} /></Button>}
    <div ref={strip} className="task-filter-strip" aria-label="Task due date filters" data-testid="task-filters">
      {filters.map(([key, label]) => <Button key={key} variant={selected === key ? 'default' : 'outline'} size="sm" aria-pressed={selected === key} onClick={() => onSelect(key)} data-testid={`task-filter-${key}`}>{label}<span className="ml-1.5" data-testid={`task-count-${key}`}>{counts[key]}</span></Button>)}
    </div>
    {edges.overflow && <Button size="icon" variant="ghost" disabled={edges.end} onClick={() => scroll(1)} aria-label="More task filters" title="More filters" data-testid="task-filters-next"><ChevronRight size={16} /></Button>}
  </div>;
};